// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as DriverEarningsConfig from "./DriverEarningsConfig.bs.js";

function fetchDriverEarningSummaries(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/" + (msisdn + "/weekly_earning_summary?max_week_start_date=&num_weeks=4"));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._2(DriverEarningsConfig.DriverEarningsResponseConverter.execute, result, msisdn);
                        });
            });
}

function fetchDriverDailyEarningDetails(msisdn, date, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/" + (msisdn + ("/get_weekly_earning_report?max_week_start_date=" + (date + "&num_weeks=1"))));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._2(DriverEarningsConfig.DriverDailyEarningsResponseConverter.execute, result, msisdn);
                        });
            });
}

var DriverEarningsRepo = {
  fetchDriverEarningSummaries: fetchDriverEarningSummaries,
  fetchDriverDailyEarningDetails: fetchDriverDailyEarningDetails
};

export {
  DriverEarningsRepo ,
  
}
/* Config Not a pure module */
